export default {
  // 页面文本
  title: "用户分享的画布",
  from: "来自",
  userUid: "用户",
  sharedCanvas: "分享的画布：",

  // 按钮
  saveCanvas: "保存画布",
};
